import { Box } from '@chakra-ui/react';
import React from 'react';
import Name from './Name';
import EmailAddress from './EmailAddress';
import MobileNumber from './MobileNumber';
import MonthYearGraduation from './MonthYearGraduation';
import CollegeEmailAddress from './CollegeEmailAddress';
import { useDomainConfig } from '../../../../hooks/useDomainConfig';
import { SAGEX_ORG_KEY } from '../../../../utils/segexOrgName';

const ProfileFields = () => {
	const { data } = useDomainConfig({ uiHost: window.location.host });
	const [openEditModal, setOpenEditModal] = React.useState(false);
	const [editField, setEditField] = React.useState('');
	const isSagex = data?.key === SAGEX_ORG_KEY;
	return (
		<Box mt="16px" display={'grid'} gridTemplateColumns={{ md: 'repeat(2,1fr)' }} gap="16px">
			<Name />
			<MobileNumber />
			<CollegeEmailAddress />
			{/* <EmailAddress /> */}
			{!isSagex && <MonthYearGraduation />}
		</Box>
	);
};

export default ProfileFields;
